import React from "react";

export const GraphBar = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="60"
      height="61"
      viewBox="0 0 60 61"
      fill="none"
      {...props}
    >
      <g clip-path="url(#clip0_59_1433)">
        <path
          d="M5.31423 28.9084L54.5999 6.49413M54.5999 6.49413L45.3857 3.02271M54.5999 6.49413L51.1714 15.7084M56.7857 58.7798H46.0714V28.7798C46.0714 28.2115 46.2971 27.6665 46.699 27.2646C47.1009 26.8628 47.6459 26.637 48.2142 26.637H54.6428C55.2111 26.637 55.7562 26.8628 56.158 27.2646C56.5599 27.6665 56.7857 28.2115 56.7857 28.7798V58.7798ZM35.3571 58.7798H24.6428V35.2084C24.6428 34.6401 24.8686 34.0951 25.2704 33.6932C25.6723 33.2913 26.2173 33.0656 26.7857 33.0656H33.2142C33.7826 33.0656 34.3276 33.2913 34.7295 33.6932C35.1313 34.0951 35.3571 34.6401 35.3571 35.2084V58.7798ZM13.9285 58.7798H3.21423V41.637C3.21423 41.0687 3.44 40.5236 3.84186 40.1218C4.24373 39.7199 4.78877 39.4941 5.35709 39.4941H11.7857C12.354 39.4941 12.899 39.7199 13.3009 40.1218C13.7028 40.5236 13.9285 41.0687 13.9285 41.637V58.7798Z"
          stroke="#4F9CF9"
          stroke-width="4.28571"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_59_1433">
          <rect
            width="60"
            height="60"
            fill="white"
            transform="translate(0 0.879883)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
